import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, createElementBlock as _createElementBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createVNode as _createVNode, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "relative text-slate-600 rounded-xl w-full overflow-hidden group" }
const _hoisted_2 = { class: "aspect-w-16 aspect-h-9 bg-white" }
const _hoisted_3 = { class: "absolute inset-0 flex justify-center items-center" }
const _hoisted_4 = {
  key: 1,
  class: "animate-spin h-6 w-6 text-slate-600",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "absolute top-2 left-1/2 -translate-x-1/2 flex space-x-1.5 z-[2] opacity-0 group-hover:opacity-100 transition-opacity" }
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "animate-pulse absolute text-red-600 right-3 top-0 z-[1] flex justify-end pt-2 items-center gap-2 opacity-100 group-hover:opacity-0 group-hover:animate-none"
}
const _hoisted_12 = { class: "text-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConnectAvatar = _resolveComponent("ConnectAvatar")!
  const _component_DeviceErrorTooltip = _resolveComponent("DeviceErrorTooltip")!
  const _component_LoadingOutlined = _resolveComponent("LoadingOutlined")!
  const _component_MicrophoneIcon = _resolveComponent("MicrophoneIcon")!
  const _component_Cog6ToothIcon = _resolveComponent("Cog6ToothIcon")!
  const _component_ArrowsPointingInIcon = _resolveComponent("ArrowsPointingInIcon")!
  const _component_WifiIcon = _resolveComponent("WifiIcon")!
  const _component_NameTag = _resolveComponent("NameTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("figure", null, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.isAvatarShown)
            ? (_openBlock(), _createBlock(_component_ConnectAvatar, {
                key: 0,
                src: _ctx.avatarTeacher,
                alt: _ctx.teacher?.name
              }, null, 8, ["src", "alt"]))
            : _withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[5] || (_cache[5] = [
                _createElementVNode("circle", {
                  class: "opacity-25",
                  cx: "12",
                  cy: "12",
                  r: "10",
                  stroke: "currentColor",
                  "stroke-width": "4"
                }, null, -1),
                _createElementVNode("path", {
                  class: "opacity-75",
                  fill: "currentColor",
                  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                }, null, -1)
              ]))], 512)), [
                [_vShow, _ctx.spinnerVisible]
              ])
        ]),
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass(['w-full h-full object-cover', !_ctx.isTeacherCalling && 'hidden']),
          id: _ctx.teacher?.id,
          ref: "videoRef"
        }, null, 10, _hoisted_5), [
          [_vShow, _ctx.isVideoPublished]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (!_ctx.isMeHelper && _ctx.isJoinedSession)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_7, [
              (_ctx.cameraError.isError)
                ? (_openBlock(), _createBlock(_component_DeviceErrorTooltip, {
                    key: 0,
                    class: "absolute right-[-30%] top-[-30%]",
                    message: _ctx.cameraErrorMessage,
                    altText: 'Camera error info'
                  }, null, 8, ["message"]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cameraError.isError ? _ctx.openDeviceWarningModal(true) : _ctx.toggleVideo())),
                disabled: _ctx.isCameraToggling,
                class: "h-7 w-7 bg-slate-100/80 flex items-center justify-center rounded-md hover:bg-white hover:shadow transition-colors cursor-pointer disabled:cursor-wait"
              }, [
                (_ctx.isCameraToggling)
                  ? (_openBlock(), _createBlock(_component_LoadingOutlined, {
                      key: 0,
                      class: "animate-spin"
                    }))
                  : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.isVideoPublished ? _ctx.VideoCameraIcon : _ctx.VideoCameraSlashIcon), {
                      key: 1,
                      class: "h-4 w-4"
                    }))
              ], 8, _hoisted_8)
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_ctx.microphoneError.isError)
                ? (_openBlock(), _createBlock(_component_DeviceErrorTooltip, {
                    key: 0,
                    class: "absolute right-[-30%] top-[-30%]",
                    message: _ctx.microphoneErrorMessage,
                    altText: 'Microphone error info'
                  }, null, 8, ["message"]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.microphoneError.isError ? _ctx.openDeviceWarningModal(false) : _ctx.toggleAudio())),
                disabled: _ctx.isMicrophoneToggling,
                class: "h-7 w-7 bg-slate-100/80 flex items-center justify-center rounded-md hover:bg-white hover:shadow transition-colors cursor-pointer disabled:cursor-wait"
              }, [
                (_ctx.isMicrophoneToggling)
                  ? (_openBlock(), _createBlock(_component_LoadingOutlined, {
                      key: 0,
                      class: "animate-spin"
                    }))
                  : (_openBlock(), _createBlock(_component_MicrophoneIcon, {
                      key: 1,
                      "icon-class": "h-4 w-4",
                      enabled: _ctx.isAudioPublished
                    }, null, 8, ["enabled"]))
              ], 8, _hoisted_10)
            ]),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleClickShowDeviceModal && _ctx.handleClickShowDeviceModal(...args))),
              class: "h-7 w-7 bg-slate-100/80 flex items-center justify-center rounded-md hover:bg-white hover:shadow transition-colors cursor-pointer"
            }, [
              _createVNode(_component_Cog6ToothIcon, { class: "h-4 w-4" })
            ])
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickMinimized && _ctx.onClickMinimized(...args))),
        class: "h-7 w-7 bg-slate-100/80 flex items-center justify-center rounded-md hover:bg-white hover:shadow transition-colors cursor-pointer"
      }, [
        _createVNode(_component_ArrowsPointingInIcon, { class: "h-4 w-4" })
      ]),
      (_ctx.isMeHelper && _ctx.isInOneToOneMode && !_ctx.anotherTeacherIsInOneToOneMode)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleOneToOneWithHelperIgnoreTeacherVoice && _ctx.toggleOneToOneWithHelperIgnoreTeacherVoice(...args))),
            class: "h-7 w-7 bg-slate-100/80 flex items-center justify-center rounded-md hover:bg-white hover:shadow transition-colors cursor-pointer"
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.isOneToOneWithHelperIgnoreTeacherVoice ? _ctx.SpeakerXMarkIcon : _ctx.SpeakerWaveIcon), { class: "h-4 w-4" }))
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isLowBandWidth)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(_component_WifiIcon, { class: "size-6" }),
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.poorConnectionText), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_NameTag, {
      name: _ctx.teacher?.name,
      "is-muted": !_ctx.isAudioPublished,
      class: "absolute bottom-2 left-3"
    }, null, 8, ["name", "is-muted"])
  ]))
}